import { isEqual } from 'lodash';
import { store } from 'shared/stores/core/decorators';

@store('USER_RIGHTS')
export class UserImageRightsStore {
  state = {
    rightsByImageId: {},
    currentRights: null
  };

  async IMAGE_SELECTED ({dispatch, state, resources}) {
    const asyncImageId = state('IMAGE').selectedImageId;

    if (!this.state.rightsByImageId[asyncImageId]) {
      // Load them from the server and update state.
      const userImageRightsProvider = resources.get('USER_RIGHTS');
      const response = await userImageRightsProvider.get(asyncImageId);
      this.state.rightsByImageId[asyncImageId] = createRights(response.data);
    }

    // Since the above is async we set currentRights to whatever is the *current* selectedImageId. This takes a minute
    // or two to wrap your brain around but is in fact correct. Just think about it for a sec and you'll get it.
    const currentImageId = state('IMAGE').selectedImageId;
    const oldRights = this.state.currentRights;
    const newRights = this.state.rightsByImageId[currentImageId];
    this.state.currentRights = newRights;

    // If rights have changed then let folks know.
    if (haveRightsChanged(oldRights, newRights)) {
      dispatch('USER_RIGHTS_CHANGED');
    }
  }
}

// This function serves 2 purposes:
// 1. It shows the structure of a UserRights object
// 2. It ensures all rights are consistently created
function createRights ({saveAnnotation = false, saveMacro = false, runAnalysis = false, viewLabel = false}) {
  return {
    saveAnnotation,
    saveMacro,
    runAnalysis,
    viewLabel
  };
}

// Most of the time users will have the same rights across images, so we need something a little more complex than
// an object-identity check
function haveRightsChanged (oldState, newState) {
  return (newState && (Object.getOwnPropertyNames(newState).length > 0) && !isEqual(oldState, newState));
}



// WEBPACK FOOTER //
// ./src/shared/stores/user/image-rights/UserImageRightsStore.js